import React from "react";
import ReactMarkdown from "react-markdown";

function AiMessage({ message, threeDots }) {
    // Ensure message is a string. If not, convert it to a string or use an empty string.
    const safeMessage = typeof message === "string" ? message : (message ? JSON.stringify(message) : "");
  
    return (
        <div className="aiMessageContainer">
            <div className="aiMessageBubble">
                {threeDots ? (
                    <div className="kursvaljaredot-flashing"></div> // Three dots flashing
                ) : (
                    <ReactMarkdown 
                        components={{
                            a: ({ children, ...props }) => (
                                <a {...props} target="_blank" rel="noopener noreferrer">
                                    {children || "Link"} {/* Fallback content to avoid empty links */}
                                </a>
                            ),
                        }}
                    >
                        {safeMessage.trim().replace(/\\n/g, "\n")}
                    </ReactMarkdown>
                )}
            </div>
        </div>
    );
}

export default AiMessage;
